// StudentNavBar.js
import React, { useState, useEffect } from "react";
import logo from "../../images/logo.svg";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import "./StudentNavBar.css";

const StudentNavBar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, [auth]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/student-login");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <nav className="student-navbar">
      <div className="student-navbar-container">
        <div className="student-logo">
          <img
            src={logo}
            alt="Logo"
            className="student-logo-img"
          />
        </div>
        {isLoggedIn && (
          <div className="navbar-buttons">
            <button className="student-logout-button" onClick={handleLogout}>
              Log out
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default StudentNavBar;
